import React from 'react';
import './BooleanIcon.css';

export default function BooleanIcon(props) {
	return (parseInt(props.value, 10) === 1)
		? <i className="bi bi-check-circle-fill boolean-icon"></i>
		: <i className="bi bi-circle boolean-icon"></i>;
};
